import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';

export default function IconArrowLeft({className, height, title}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M6.93141 13.5029C6.88686 13.5029 6.86455 13.5568 6.89605 13.5883L10.6768 17.369C10.8721 17.5643 10.8721 17.8809
      10.6768 18.0761L10.3233 18.4297C10.128 18.6249 9.81142 18.6249 9.61615 18.4297L4.29293 13.1065C4.09767 12.9112
      4.09767 12.5946 4.29293 12.3994L9.61615 7.07613C9.81142 6.88087 10.128 6.88087 10.3233 7.07613L10.6768
      7.42969C10.8721 7.62495 10.8721 7.94153 10.6768 8.13679L6.89605 11.9176C6.86455 11.9491 6.88686 12.0029 6.93141
      12.0029H18C18.2762 12.0029 18.5 12.2268 18.5 12.5029V13.0029C18.5 13.2791 18.2762 13.5029 18 13.5029H6.93141Z
    </Icon>
  );
}
